import React from "react";

import DashboardHomeView from "components/DashboardHomeView";
import useController from "./controller";

export default function ManagedPortalHome({ portal }) {
    const { hero, loading, sections, handleAction } = useController(portal);

    return (
        <DashboardHomeView
            handleAction={handleAction}
            hero={hero}
            loading={loading}
            sections={sections}
        />
    );
}
